export default {
  // Page titles and navigation
  'pages.water-fee.title': 'Water Fee',
  'pages.water-fee.subtitle': 'Manage community water bill generation, payment and inquiry',
  'pages.water-fee.currentSelection': 'Current selection:',
  'pages.water-fee.batchImport': 'Batch Import',
  'pages.water-fee.treeTitle': 'Building Floor House Selection',
  'pages.water-fee.tabOther': 'Other',

  // Breadcrumb navigation
  'pages.breadcrumb.chargeManagement': 'Charge Management',
  'pages.breadcrumb.waterFee': 'Water Fee',

  // Table related
  'pages.water-fee.table.title': 'Water Fee Bill List',
  'pages.water-fee.table.houseInfo': 'House Info',
  'pages.water-fee.table.period': 'Period',
  'pages.water-fee.table.billNo': 'Bill No.',
  'pages.water-fee.table.waterUsage': 'Water Usage (Ton)',
  'pages.water-fee.table.totalAmount': 'Total Amount',
  'pages.water-fee.table.paymentAmount': 'Payment Amount',
  'pages.water-fee.table.dueAmount': 'Due',
  'pages.water-fee.table.actualAmount': 'Paid',
  'pages.water-fee.table.approvalStatus': 'Approval Status',
  'pages.water-fee.table.paymentStatus': 'Payment Status',
  'pages.water-fee.table.paymentTime': 'Payment Time',
  'pages.water-fee.table.dueDate': 'Due Date',
  'pages.water-fee.table.action': 'Action',

  // Action buttons
  'pages.water-fee.action.view': 'View',
  'pages.water-fee.action.edit': 'Edit',
  'pages.water-fee.action.delete': 'Delete',
  'pages.water-fee.action.create': 'Create Bill',
  'pages.water-fee.action.submitAudit': 'Submit Audit',
  'pages.water-fee.action.batchDelete': 'Batch Delete',
  'pages.water-fee.action.confirm': 'Confirm',
  'pages.water-fee.action.cancel': 'Cancel',

  // Delete related
  'pages.water-fee.delete.confirmTitle': 'Are you sure you want to delete this record?',
  'pages.water-fee.delete.success': 'Deleted successfully',
  'pages.water-fee.delete.failure': 'Delete failed',
  'pages.water-fee.delete.batchDelete.confirmTitle': 'Confirm Delete',
  'pages.water-fee.delete.batchDelete.confirmMessage': 'Are you sure you want to delete the selected {count} records?',
  'pages.water-fee.batchDelete.success': 'Batch delete successful',
  'pages.water-fee.batchDelete.failure': 'Batch delete failed',
  'pages.water-fee.delete.batchDelete.noSelection': 'Please select records to delete',
  'pages.water-fee.delete.batchDelete.draftOnly': 'Batch deletion is only available for draft bills',

  // Audit related
  'pages.water-fee.audit.selectBillsWarning': 'Please select bills to submit for audit',
  'pages.water-fee.audit.modalTitle': 'Submit Audit',
  'pages.water-fee.audit.submitAudit': 'Submit Audit',
  'pages.water-fee.audit.auditName': 'Audit Name',
  'pages.water-fee.audit.auditNamePlaceholder': 'Please enter audit name',
  'pages.water-fee.audit.auditNameRequired': 'Please enter audit name',
  'pages.water-fee.audit.submitRemark': 'Submit Remarks',
  'pages.water-fee.audit.submitRemarkPlaceholder': 'Please enter submit remarks (optional)',
  'pages.water-fee.audit.selectedBillsTitle': 'Selected Bills List (Total {count})',
  'pages.water-fee.audit.success': 'Audit submitted successfully',
  'pages.water-fee.audit.failure': 'Audit submission failed',
  'pages.water-fee.audit.defaultName': '{period} Water Fee Bills ({count})',

  // Detail modal
  'pages.water-fee.detail.modalTitle': 'Water Fee Bill Details',
  'pages.water-fee.detail.basicInfo': 'Basic Information',

  // Detail fields
  'pages.water-fee.detail.billNo': 'Bill No.',
  'pages.water-fee.detail.period': 'Period',
  'pages.water-fee.detail.paymentStatus': 'Payment Status',
  'pages.water-fee.detail.approvalStatus': 'Approval Status',
  'pages.water-fee.detail.startDate': 'Start Date',
  'pages.water-fee.detail.endDate': 'End Date',
  'pages.water-fee.detail.houseInfo': 'House Information',
  'pages.water-fee.detail.ownerInfo': 'Owner Information',
  'pages.water-fee.detail.ownerIdCard': 'ID Card',
  'pages.water-fee.detail.ownerEmail': 'Email',
  'pages.water-fee.detail.ownerId': 'Owner ID',
  'pages.water-fee.detail.lastReading': 'Last Reading (Ton)',
  'pages.water-fee.detail.lastReadingDate': 'Last Reading Date',
  'pages.water-fee.detail.currentReading': 'Current Reading (Ton)',
  'pages.water-fee.detail.currentReadingDate': 'Current Reading Date',
  'pages.water-fee.detail.waterUsage': 'Water Usage',
  'pages.water-fee.detail.unitPrice': 'Unit Price (₱/Ton)',
  'pages.water-fee.detail.baseAmount': 'Base Amount',
  'pages.water-fee.detail.lateFee': 'Late Fee',
  'pages.water-fee.detail.discountAmount': 'Discount Amount',
  'pages.water-fee.detail.finalAmount': 'Final Amount',
  'pages.water-fee.detail.paymentMethod': 'Payment Method',
  'pages.water-fee.detail.paymentReference': 'Payment Reference',
  'pages.water-fee.detail.dueDate': 'Due Date',
  'pages.water-fee.detail.paymentDate': 'Payment Date',
  'pages.water-fee.detail.createdTime': 'Created Time',
  'pages.water-fee.detail.updatedTime': 'Updated Time',
  'pages.water-fee.detail.remarks': 'Remarks',

  // Form related
  'pages.water-fee.form.editTitle': 'Edit Water Fee Bill',
  'pages.water-fee.form.createTitle': 'Create Water Fee Bill',
  'pages.water-fee.form.basicInfo': 'Basic Information',
  'pages.water-fee.form.houseOwnerInfo': 'House & Owner Information',
  'pages.water-fee.form.meterReadingInfo': 'Meter Reading Information',
  'pages.water-fee.form.feeInfo': 'Fee Information',
  'pages.water-fee.form.remarksInfo': 'Remarks',
  'pages.water-fee.form.update': 'Update',
  'pages.water-fee.form.create': 'Create',
  'pages.water-fee.form.cancel': 'Cancel',

  // Form fields
  'pages.water-fee.form.billNo': 'Bill No.',
  'pages.water-fee.form.billNoPlaceholder': 'Please enter bill number',
  'pages.water-fee.form.paymentStatus': 'Payment Status',
  'pages.water-fee.form.paymentStatusPlaceholder': 'Please select payment status',
  'pages.water-fee.form.period': 'Period',
  'pages.water-fee.form.periodPlaceholder': 'e.g.: 2024-01',
  'pages.water-fee.form.periodRequired': 'Please enter period',
  'pages.water-fee.form.startDate': 'Start Date',
  'pages.water-fee.form.startDatePlaceholder': 'Please select start date',
  'pages.water-fee.form.startDateRequired': 'Please select start date',
  'pages.water-fee.form.endDate': 'End Date',
  'pages.water-fee.form.endDatePlaceholder': 'Please select end date',
  'pages.water-fee.form.endDateRequired': 'Please select end date',
  'pages.water-fee.form.building': 'Building',
  'pages.water-fee.form.buildingPlaceholder': 'Please select building',
  'pages.water-fee.form.buildingRequired': 'Please select building',
  'pages.water-fee.form.floor': 'Floor',
  'pages.water-fee.form.floorPlaceholder': 'Please select floor',
  'pages.water-fee.form.floorRequired': 'Please select floor',
  'pages.water-fee.form.house': 'House',
  'pages.water-fee.form.housePlaceholder': 'Please select house',
  'pages.water-fee.form.houseRequired': 'Please select house',
  'pages.water-fee.form.lastReading': 'Last Reading',
  'pages.water-fee.form.lastReadingPlaceholder': 'Please enter last reading',
  'pages.water-fee.form.lastReadingDate': 'Last Reading Date',
  'pages.water-fee.form.lastReadingDatePlaceholder': 'Please select last reading date',
  'pages.water-fee.form.currentReading': 'Current Reading',
  'pages.water-fee.form.currentReadingPlaceholder': 'Please enter current reading',
  'pages.water-fee.form.currentReadingRequired': 'Please enter current reading',
  'pages.water-fee.form.currentReadingDate': 'Current Reading Date',
  'pages.water-fee.form.currentReadingDatePlaceholder': 'Please select current reading date',
  'pages.water-fee.form.currentReadingDateRequired': 'Please select current reading date',
  'pages.water-fee.form.waterUsage': 'Water Usage',
  'pages.water-fee.form.waterUsageAuto': 'Auto Calculate',
  'pages.water-fee.form.unitPrice': 'Unit Price',
  'pages.water-fee.form.unitPricePlaceholder': 'Please enter unit price',
  'pages.water-fee.form.unitPriceRequired': 'Please enter unit price',
  'pages.water-fee.form.baseAmount': 'Base Amount',
  'pages.water-fee.form.baseAmountAuto': 'Auto Calculate',
  'pages.water-fee.form.lateFee': 'Late Fee',
  'pages.water-fee.form.lateFeePlaceholder': 'Please enter late fee',
  'pages.water-fee.form.discountAmount': 'Discount Amount',
  'pages.water-fee.form.discountAmountPlaceholder': 'Please enter discount amount',
  'pages.water-fee.form.finalAmount': 'Final Amount',
  'pages.water-fee.form.finalAmountAuto': 'Auto Calculate',
  'pages.water-fee.form.finalAmountRequired': 'Final amount will be calculated automatically',
  'pages.water-fee.form.remarks': 'Remarks',
  'pages.water-fee.form.remarksPlaceholder': 'Please enter remarks',
  'pages.water-fee.form.remarksMaxLength': 'Remarks length cannot exceed 500 characters',

  // Form validation and error messages
  'pages.water-fee.form.serviceNotAvailable': 'This house does not have water fee service enabled, please select another house',
  'pages.water-fee.form.loadPriceConfigError': 'Failed to load water fee price configuration',
  'pages.water-fee.form.submitSuccess': 'Created successfully',
  'pages.water-fee.form.updateSuccess': 'Updated successfully',
  'pages.water-fee.form.submitError': 'Submission failed',

  // Currency unit
  'pages.water-fee.currency.php': '₱',

  // Pagination
  'pages.water-fee.table.pagination.showTotal': 'Items {start}-{end} of {total}',

  // Import related
  'pages.water-fee.import.modalTitle': 'Batch Import Water Fee Bills',
  'pages.water-fee.import.confirmImport': 'Confirm Import',
  'pages.water-fee.import.cancel': 'Cancel',
  'pages.water-fee.import.step1': 'Step 1: Download Import Template',
  'pages.water-fee.import.downloadTemplate': 'Download Water Fee Bill Excel Template',
  'pages.water-fee.import.step2': 'Step 2: Select Period and Upload Completed Excel File',
  'pages.water-fee.import.selectPeriod': 'Select Period:',
  'pages.water-fee.import.selectPeriodPlaceholder': 'Please select period',
  'pages.water-fee.import.uploadFile': 'Upload File:',
  'pages.water-fee.import.uploadHint': 'Click or drag Excel file to this area',
  'pages.water-fee.import.uploadFormatHint': 'Only supports .xls and .xlsx format Excel files, file size not exceeding 10MB',
  'pages.water-fee.import.notices': 'Notes:',
  'pages.water-fee.import.notice1': 'Please select period and Excel file first, then click "Confirm Import" button',
  'pages.water-fee.import.notice2': 'Please download template and fill data according to template format',
  'pages.water-fee.import.notice3': 'Required fields cannot be empty',
  'pages.water-fee.import.notice4': 'Please fill date format according to template examples',
  'pages.water-fee.import.notice5': 'Please check data accuracy before importing',
  'pages.water-fee.import.notice6': 'If any row data is abnormal, it will not be imported',
  'pages.water-fee.import.notice7': 'If data already exists, it will not be imported',
  'pages.water-fee.import.notice8': 'Importing large amounts of data may be slower, please wait patiently',
  'pages.water-fee.import.successTitle': 'Import Request Submitted',
  'pages.water-fee.import.successMessage': 'Data is being imported, please refresh the page later to view import results!',
  'pages.water-fee.import.selectPeriodFirst': 'Please select period first!',
  'pages.water-fee.import.selectFileFirst': 'Please select Excel file to upload first!',
  'pages.water-fee.import.invalidFile': 'Invalid file, please select again!',
  'pages.water-fee.import.importFailed': 'Import failed, please check file format',
  'pages.water-fee.import.downloadSuccess': 'Template downloaded successfully',
  'pages.water-fee.import.downloadFailed': 'Template download failed',
  'pages.water-fee.import.downloadFormatError': 'Downloaded file format is incorrect',
  'pages.water-fee.import.downloadEmptyError': 'Downloaded file is empty',
  'pages.water-fee.import.fileSizeError': 'File size cannot exceed 10MB!',

  // Period query modal
  'pages.water-fee.period.modalTitle': 'Room Query - {houseName} - Period {period}',
  'pages.water-fee.period.noData': 'No Data',
  'pages.water-fee.period.currentMonthUsage': 'Current Month Usage',
  'pages.water-fee.period.currentMonthAmount': 'Current Month Amount',
  'pages.water-fee.period.avgUsage': 'Average Usage',
  'pages.water-fee.period.currentMonthPrice': 'Current Month Price',
  'pages.water-fee.period.usageChange': 'Usage Change',
  'pages.water-fee.period.vsLastMonth': 'vs Last Month',
  'pages.water-fee.period.noComparisonData': 'No Comparison Data',
  'pages.water-fee.period.amountChange': 'Amount Change',
  'pages.water-fee.period.vsLastMonthAmount': 'vs Last Month Amount',
  'pages.water-fee.period.avgPrice': 'Average Price',
  'pages.water-fee.period.pricePerTon': 'Per Ton (incl. service fee)',
  'pages.water-fee.period.usageTrendTitle': 'Last 6 Months Usage Trend',
  'pages.water-fee.period.amountTrendTitle': 'Last 6 Months Amount Trend',
  'pages.water-fee.period.detailTableTitle': 'Monthly Detailed Data',
  'pages.water-fee.period.month': 'Month',
  'pages.water-fee.period.unitPrice': 'Unit Price (₱/Ton)',
  'pages.water-fee.period.amount': 'Amount (₱)',
  'pages.water-fee.period.lateFee': 'Late Fee (₱)',
  'pages.water-fee.period.discountAmount': 'Discount Amount (₱)',
  'pages.water-fee.period.finalAmount': 'Final Amount (₱)',
  'pages.water-fee.period.status': 'Status',

  // Status related
  'pages.water-fee.status.unpaid': 'Unpaid',
  'pages.water-fee.status.paid': 'Paid',
  'pages.water-fee.status.overdue': 'Overdue',
  'pages.water-fee.status.partial': 'Partial',
  'pages.water-fee.status.cancelled': 'Cancelled',

  // Approval status
  'pages.water-fee.approvalStatus.draft': 'Draft',
  'pages.water-fee.approvalStatus.pending': 'Pending',
  'pages.water-fee.approvalStatus.approved': 'Approved',
  'pages.water-fee.approvalStatus.rejected': 'Rejected',
  'pages.water-fee.approvalStatus.notified': 'Notified',
  'pages.water-fee.approvalStatus.overdue': 'Overdue',
  'pages.water-fee.approvalStatus.cancelled': 'Cancelled',

  // Detail modal hardcoded texts
  'pages.water-fee.detail.houseOwnerInfo': 'House & Owner Information',
  'pages.water-fee.detail.houseInfo': 'House Information',
  'pages.water-fee.detail.ownerInfo': 'Owner Information',
  'pages.water-fee.detail.ownerId': 'Owner ID',
  'pages.water-fee.detail.meterReadingInfo': 'Meter Reading Information',
  'pages.water-fee.detail.lastReading': 'Last Reading (Ton)',
  'pages.water-fee.detail.lastReadingDate': 'Last Reading Date',
  'pages.water-fee.detail.currentReading': 'Current Reading (Ton)',
  'pages.water-fee.detail.currentReadingDate': 'Current Reading Date',
  'pages.water-fee.detail.waterUsage': 'Water Usage',
  'pages.water-fee.detail.unitPrice': 'Unit Price (₱/Ton)',
  'pages.water-fee.detail.amountInfo': 'Amount Information',
  'pages.water-fee.detail.baseAmount': 'Base Amount',
  'pages.water-fee.detail.lateFee': 'Late Fee',
  'pages.water-fee.detail.discountAmount': 'Discount Amount',
  'pages.water-fee.detail.finalAmount': 'Final Amount',
  'pages.water-fee.detail.paymentInfo': 'Payment Information',
  'pages.water-fee.detail.paymentMethod': 'Payment Method',
  'pages.water-fee.detail.paymentReference': 'Payment Reference',
  'pages.water-fee.detail.dueDate': 'Due Date',
  'pages.water-fee.detail.paymentDate': 'Payment Date',
  'pages.water-fee.detail.systemInfo': 'System Information',
  'pages.water-fee.detail.createdTime': 'Created Time',
  'pages.water-fee.detail.updatedTime': 'Updated Time',
  'pages.water-fee.detail.remarks': 'Remarks',
  'pages.water-fee.detail.auditRecord': 'Audit Records',
  'pages.water-fee.detail.loading': 'Loading...',
  'pages.water-fee.detail.noAuditRecord': 'No audit records',

  // Form field hardcoded texts
  'pages.water-fee.form.basicInfo': 'Basic Information',
  'pages.water-fee.form.houseOwnerInfo': 'House & Owner Information',
  'pages.water-fee.form.meterReadingInfo': 'Meter Reading Information',
  'pages.water-fee.form.feeInfo': 'Fee Information',
  'pages.water-fee.form.remarksInfo': 'Remarks',

  // Form field labels and placeholders
  'pages.water-fee.form.billNo.label': 'Bill No.',
  'pages.water-fee.form.billNo.placeholder': 'Please enter bill number',
  'pages.water-fee.form.paymentStatus.label': 'Payment Status',
  'pages.water-fee.form.paymentStatus.placeholder': 'Please select payment status',
  'pages.water-fee.form.period.label': 'Period',
  'pages.water-fee.form.period.placeholder': 'e.g.: 2024-01',
  'pages.water-fee.form.period.required': 'Please enter period',
  'pages.water-fee.form.startDate.label': 'Start Date',
  'pages.water-fee.form.startDate.placeholder': 'Please select start date',
  'pages.water-fee.form.startDate.required': 'Please select start date',
  'pages.water-fee.form.endDate.label': 'End Date',
  'pages.water-fee.form.endDate.placeholder': 'Please select end date',
  'pages.water-fee.form.endDate.required': 'Please select end date',
  'pages.water-fee.form.building.label': 'Building',
  'pages.water-fee.form.building.placeholder': 'Please select building',
  'pages.water-fee.form.building.required': 'Please select building',
  'pages.water-fee.form.floor.label': 'Floor',
  'pages.water-fee.form.floor.placeholder': 'Please select floor',
  'pages.water-fee.form.floor.required': 'Please select floor',
  'pages.water-fee.form.house.label': 'House',
  'pages.water-fee.form.house.placeholder': 'Please select house',
  'pages.water-fee.form.house.required': 'Please select house',
  'pages.water-fee.form.lastReading.label': 'Last Reading',
  'pages.water-fee.form.lastReading.placeholder': 'Please enter last reading',
  'pages.water-fee.form.lastReadingDate.label': 'Last Reading Date',
  'pages.water-fee.form.lastReadingDate.placeholder': 'Please select last reading date',
  'pages.water-fee.form.currentReading.label': 'Current Reading',
  'pages.water-fee.form.currentReading.placeholder': 'Please enter current reading',
  'pages.water-fee.form.currentReading.required': 'Please enter current reading',
  'pages.water-fee.form.currentReadingDate.label': 'Current Reading Date',
  'pages.water-fee.form.currentReadingDate.placeholder': 'Please select current reading date',
  'pages.water-fee.form.currentReadingDate.required': 'Please select current reading date',
  'pages.water-fee.form.waterUsage.label': 'Water Usage',
  'pages.water-fee.form.waterUsage.placeholder': 'Auto Calculate',
  'pages.water-fee.form.unitPrice.label': 'Unit Price',
  'pages.water-fee.form.unitPrice.placeholder': 'Please enter unit price',
  'pages.water-fee.form.unitPrice.required': 'Please enter unit price',
  'pages.water-fee.form.baseAmount.label': 'Base Amount',
  'pages.water-fee.form.baseAmount.placeholder': 'Auto Calculate',
  'pages.water-fee.form.lateFee.label': 'Late Fee',
  'pages.water-fee.form.lateFee.placeholder': 'Please enter late fee',
  'pages.water-fee.form.discountAmount.label': 'Discount Amount',
  'pages.water-fee.form.discountAmount.placeholder': 'Please enter discount amount',
  'pages.water-fee.form.finalAmount.label': 'Final Amount',
  'pages.water-fee.form.finalAmount.placeholder': 'Auto Calculate',
  'pages.water-fee.form.finalAmount.required': 'Final amount will be calculated automatically',
  'pages.water-fee.form.remarks.label': 'Remarks',
  'pages.water-fee.form.remarks.placeholder': 'Please enter remarks',
  'pages.water-fee.form.remarks.maxLength': 'Remarks length cannot exceed 500 characters',

  // Import modal remaining hardcoded texts
  'pages.water-fee.import.modalTitle': 'Batch Import Water Fee Bills',
  'pages.water-fee.import.step1.title': 'Step 1: Download Import Template',
  'pages.water-fee.import.step2.title': 'Step 2: Select Period and Upload Completed Excel File',
  'pages.water-fee.import.selectPeriod.label': 'Select Period:',

  // Period query modal hardcoded texts
  'pages.water-fee.period.modalTitle': 'Room Query - {houseName} - Period {period}',
  'pages.water-fee.period.currentMonthUsage': 'Current Month Usage',
  'pages.water-fee.period.currentMonthAmount': 'Current Month Amount',
  'pages.water-fee.period.avgUsage': 'Average Usage',
  'pages.water-fee.period.currentMonthPrice': 'Current Month Price',
  'pages.water-fee.period.usageChange': 'Usage Change',
  'pages.water-fee.period.vsLastMonth': 'vs Last Month',
  'pages.water-fee.period.noComparisonData': 'No Comparison Data',
  'pages.water-fee.period.amountChange': 'Amount Change',
  'pages.water-fee.period.vsLastMonthAmount': 'vs Last Month Amount',
  'pages.water-fee.period.avgPrice': 'Average Price',
  'pages.water-fee.period.pricePerTon': 'Per Ton (incl. service fee)',
  'pages.water-fee.period.usageTrendTitle': 'Last 6 Months Usage Trend',
  'pages.water-fee.period.amountTrendTitle': 'Last 6 Months Amount Trend',
  'pages.water-fee.period.detailTableTitle': 'Monthly Detailed Data',
  'pages.water-fee.period.month': 'Month',
  'pages.water-fee.period.unitPrice': 'Unit Price(PHP/Ton)',
  'pages.water-fee.period.amount': 'Amount(PHP)',
  'pages.water-fee.period.lateFee': 'Late Fee(PHP)',
  'pages.water-fee.period.discountAmount': 'Discount Amount(PHP)',
  'pages.water-fee.period.finalAmount': 'Final Amount(PHP)',
  'pages.water-fee.period.status': 'Status',
  'pages.water-fee.period.noData': 'No Data',

  // Units
  'pages.water-fee.unit.ton': 'Ton',
  'pages.water-fee.unit.phpPerTon': 'PHP/Ton',

  // Detail Component Fields
  'pages.water-fee.detail.basicInfo': 'Basic Information',
  'pages.water-fee.detail.billNo': 'Bill Number',
  'pages.water-fee.detail.period': 'Period',
  'pages.water-fee.detail.paymentStatus': 'Payment Status',
  'pages.water-fee.detail.approvalStatus': 'Approval Status',
  'pages.water-fee.detail.startDate': 'Start Date',
  'pages.water-fee.detail.endDate': 'End Date',
  'pages.water-fee.detail.houseOwnerInfo': 'House & Owner Information',
  'pages.water-fee.detail.houseInfo': 'House Information',
  'pages.water-fee.detail.ownerInfo': 'Owner Information',
  'pages.water-fee.detail.meterReadingInfo': 'Meter Reading Information',
  'pages.water-fee.detail.lastReading': 'Last Reading',
  'pages.water-fee.detail.lastReadingDate': 'Last Reading Date',
  'pages.water-fee.detail.currentReading': 'Current Reading',
  'pages.water-fee.detail.currentReadingDate': 'Current Reading Date',
  'pages.water-fee.detail.waterUsage': 'Water Usage',
  'pages.water-fee.detail.unitPrice': 'Unit Price',
  'pages.water-fee.detail.amountInfo': 'Amount Information',
  'pages.water-fee.detail.baseAmount': 'Base Amount',
  'pages.water-fee.detail.lateFee': 'Late Fee',
  'pages.water-fee.detail.discountAmount': 'Discount Amount',
  'pages.water-fee.detail.finalAmount': 'Final Amount',
  'pages.water-fee.detail.paymentInfo': 'Payment Information',
  'pages.water-fee.detail.paymentMethod': 'Payment Method',
  'pages.water-fee.detail.paymentReference': 'Payment Reference',
  'pages.water-fee.detail.dueDate': 'Due Date',
  'pages.water-fee.detail.paymentDate': 'Payment Date',
  'pages.water-fee.detail.systemInfo': 'System Information',
  'pages.water-fee.detail.createdTime': 'Created Time',
  'pages.water-fee.detail.updatedTime': 'Updated Time',
  'pages.water-fee.detail.remarks': 'Remarks',

  // Import filename template
  'pages.water-fee.import.templateFileName': 'Water Fee Bill Template_{timestamp}.xlsx',
};
